<!-- 商品 -->
<template>
	<div class="wrap">

		<div class="header">
			<img src="../assets/return.png" class="return-img" @click="$router.back()">
			<p class="header-title">商品</p>
		</div>

		<ul class="list">
			<li>
				<img src="../assets/video-17.png" class="item-icon">
				<div class="item-sidebar">
					<span class="item-name">购物车</span>
					<img src="../assets/back-icon.png" class="back-icon">
				</div>
			</li>
			<li>
				<img src="../assets/video-18.png" class="item-icon">
				<div class="item-sidebar">
					<span class="item-name">待付款</span>
					<img src="../assets/back-icon.png" class="back-icon">
				</div>
			</li>
			<li>
				<img src="../assets/video-19.png" class="item-icon">
				<div class="item-sidebar">
					<span class="item-name">待收货</span>
					<img src="../assets/back-icon.png" class="back-icon">
				</div>
			</li>
		</ul>

		<ul class="list">
			<li>
				<img src="../assets/video-5.png" class="item-icon">
				<div class="item-sidebar">
					<span class="item-name">我的发布</span>
					<img src="../assets/back-icon.png" class="back-icon">
				</div>
			</li>
			<li>
				<img src="../assets/video-6.png" class="item-icon">
				<div class="item-sidebar">
					<span class="item-name">我的收藏</span>
					<img src="../assets/back-icon.png" class="back-icon">
				</div>
			</li>
		</ul>

		<ul class="list">
			<li>
				<img src="../assets/video-9.png" class="item-icon">
				<div class="item-sidebar">
					<span class="item-name">浏览记录</span>
					<img src="../assets/back-icon.png" class="back-icon">
				</div>
			</li>
		</ul>


	</div>
</template>

<script>
	export default {
		components: {},
		data() {
			return {

			};
		},
		mounted() {},
		methods: {
			//稿件管理
			manuscriptManagement() {
				this.$router.push('/manuscript-management')
			},
		}
	}
</script>

<style scoped>
	.wrap {
		width: 100%;
		min-height: 100vh;
		background-color: #F4F4F4;
		display: flex;
		flex-direction: column;
		overflow: auto;
		padding-top: 44px;
	}

	/* 头部样式 */
	.header {
		width: 100%;
		height: 44px;
		display: flex;
		justify-content: center;
		align-items: center;
		position: fixed;
		top: 0;
		left: 0;
		background-color: #FFFFFF;
		z-index: 999;
	}

	.return-img {
		position: absolute;
		left: 15px;
		top: 50%;
		transform: translate(0, -50%);
		width: 20px;
	}

	.header-title {
		color: #333333;
		font-size: 18px;
		font-weight: 500;
	}

	.list {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 14px 15px;
		box-sizing: border-box;
		background-color: #FFFFFF;
		margin-bottom: 10px;
	}

	.list>li {
		width: 100%;
		display: flex;
		align-items: center;
		margin-bottom: 28px;
	}

	.list>li:last-child {
		margin-bottom: 0;
	}

	.item-icon {
		width: 48px;
		margin-right: 26px;
	}

	.item-sidebar {
		flex: 1;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.item-name {
		flex: 1;
		color: #222222;
		font-size: 15px;
		font-weight: bold;
	}

	.back-icon {
		width: 7px;
	}
</style>
